<template>
  <div class="header-wrap">
    <div class="form-wrap">
      <el-form :rules="rules" :model="formData" ref="headerTplRef">
        <div class="form-item">
          <span class="item-label">选择模板：</span>
          <div class="item-value">
            <el-button class="add-tpl" icon="el-icon-plus" type="text" @click="selectTpl">选择模板</el-button>
            <span v-show="tplMsg.tplName" class="tpl-label">模板名称：{{ tplMsg.tplName }}</span>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">广告账户：</span>
          <div class="item-value">
            <el-form-item prop="adCount" style="margin-bottom: 0px">
              <el-select
                v-model="formData.adCount"
                filterable
                :filter-method="filterMethod"
                class="count-select-wrap"
                popper-class="count-select"
                value-key="advertiserId"
                @change="searchProList()"
                placeholder="请选择账户"
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :label="`${item.company}-${item.advertiserName}`"
                  :value="item.advertiserId"
                >
                  <div class="count-option">
                    <span class="count-item">{{ item.company }}-{{ item.advertiserName }}</span>
                    <span class="count-item">ID：{{ item.advertiserId }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label">推广目标：</span>
          <div class="item-value">
            <el-radio-group v-model="formData.landing_type">
              <el-radio label="APP">应用推广</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">选择产品：</span>
          <div class="item-value">
            <el-form-item prop="selectPro">
              <div>
                <el-input style="width: 500px" placeholder="请选择产品" disabled v-model="formData.selectPro">
                  <template slot="append">
                    <el-button @click="chooseProduct" :disabled="!!alreadyProjectId">选择</el-button>
                  </template>
                </el-input>
              </div>
              <div class="product-name" v-if="chooseProductData.package_name">
                {{ chooseProductData.app_name }}（{{ chooseProductData.package_name }}）
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 模板选择弹框 -->
    <el-dialog title="选择模板" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body">
        <div class="select-filter">
          <el-select style="width: 224px" v-model="modalData.adCount" placeholder="请选择">
            <el-option label="全部广告账号" :value="-1"> </el-option>
            <el-option
              :label="item.company + '-' + item.advertiserName"
              :value="item.advertiserId"
              v-for="item of countList"
              :key="item.advertiserId"
            >
            </el-option>
          </el-select>
          <el-input style="width: 224px" placeholder="请输入内容" suffix-icon="el-icon-search" v-model.trim="modalData.searchStr">
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table :data="tplTableList" style="width: 100%" @select="selectRow" ref="tplTableRef" max-height="500px">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="序号"> </el-table-column>
            <el-table-column prop="templateName" label="名称"> </el-table-column>
            <el-table-column prop="templateDesc" label="描述"> </el-table-column>
            <el-table-column prop="advertiserNames" label="关联账号"> </el-table-column>
            <el-table-column prop="createTimeStr" width="170" label="创建时间"> </el-table-column>
            <el-table-column prop="creator" label="创建人"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <div></div>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>

    <subpackage-product ref="subpackProduct" @chooseCallback="chooseCallback"></subpackage-product>
  </div>
</template>

<script>
import { getAdCount, queryTemplate, getAdertiserProduct } from "@/api/promotion.js";
import SubpackageProduct from "./subpackageProduct.vue";
import { mapState } from "vuex";
export default {
  components: {
    SubpackageProduct,
  },
  data() {
    return {
      formData: {
        adCount: "",
        selectPro: "",
        landing_type: "APP",
      },
      chooseProductData: {},
      countList: [],
      copyCountList: [],
      proList: [],
      dialogVisible: false,

      modalData: {
        adCount: -1,
        searchStr: "",
        pageData: {
          total: 15,
          page: 1,
          size: 10,
        },
      },
      tplMsg: {
        tplId: "", //保存的时候需要
        tplDes: "",
        tplName: "",
      },
      tplList: [],
      selectData: null, //勾选的模板数据
      rules: {
        adCount: [
          {
            required: true,
            message: "请选择一个账户",
            trigger: "change",
          },
        ],
        selectPro: [
          {
            trigger: ["change"],
            validator: (rule, value, callback) => {
              if (!this.formData.selectPro) {
                callback(new Error("请选择产品"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelect();
  },
  watch: {
    checkedApp: {
      handler(val) {
        if (val) {
          const { app_name, package_name, download_url } = val;
          this.chooseProductData = {
            package_name,
            app_name,
          };
          this.formData.selectPro = download_url;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      checkedApp: (state) => state.PromotionTtV2.checkedApp,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
    }),
    tplTableList() {
      return this.tplList.filter((item) => {
        return (
          (this.modalData.adCount === item.advertiserIds || this.modalData.adCount === -1) &&
          (this.modalData.searchStr === "" || item.templateName.toLowerCase().includes(this.modalData.searchStr.toLowerCase()))
        );
      });
    },
  },
  methods: {
    initSelect() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
    },
    searchProList(data) {
      this.formData.selectPro = "";
      this.chooseProductData = {};
      this.$store.commit("setadCount_ttV2", {
        advertiser_id: this.formData.adCount,
        advertiserName: this.countList.find((item) => item.advertiserId === this.formData.adCount).advertiserName,
      });
      if (data?.app_id) {
        this.chooseProductData = data;
        this.formData.selectPro = data?.download_url;
      }
    },
    filterMethod(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
    selectTpl() {
      this.dialogVisible = true;
      queryTemplate({
        version: "v2",
      }).then((res) => {
        if (res.code === "0000") {
          this.tplList = res.adTemplates;
        }
      });
    },
    selectRow(selection, row) {
      this.selectData = row;
      this.$refs.tplTableRef.clearSelection();
      this.$refs.tplTableRef.toggleRowSelection(row, true);
    },
    confirmSelect() {
      if (this.selectData) {
        this.dialogVisible = false;
        this.renderData();
      } else {
        this.$message({
          message: "请选择一条模板数据",
          type: "warning",
        });
      }
    },
    chooseProduct() {
      if (this.formData.adCount) {
        this.$refs.subpackProduct.showModal(this.formData.adCount);
      } else {
        this.$message({
          message: "请先选择广告账户",
          type: "warning",
        });
      }
    },
    //数据回显
    renderData() {
      this.tplMsg.tplId = this.selectData.id;
      this.tplMsg.tplName = this.selectData.templateName;
      this.tplMsg.tplDes = this.selectData.templateDesc;
      //赋值广告账号
      if (this.selectData.advertiserIds) {
        this.formData.adCount = this.selectData.advertiserIds;
      }

      //表单赋值
      const data = JSON.parse(this.selectData.templateData);
      //选择的产品
      this.$store.commit("setcheckedApp_ttV2", data.checkedApp);
      this.searchProList(data.checkedApp); //带赋值的查询
      // 项目
      this.$store.commit("set_project_delivery_setting", data.deliverySetting);
      this.$store.commit("set_already_projectID", data.baseData.projectId);
      // 设置基础设置-投放内容
      this.$store.commit("set_optimize_goal_ttV2", data.optimizeGoal);
      // 设置基础设置-产品信息
      this.$store.commit("set_product_info_ttV2", data.productInfo);
      //设置基础设置-关联产品投放
      this.$store.commit("set_related_product_ttV2", data.relatedProduct);
      //设置基础设置-投放位置
      this.$store.commit("set_deliveryRange_ttV2", data.deliveryRange);
      // 设置基础设置-推广身份,原生锚点（用于回显）
      this.$store.commit("set_origin_native_data_ttV2", data.originNativeSettingData);
      //设置基础设置-人群包
      this.$store.commit("set_audience_ttV2", data.audiences);
      //设置基础设置-落地页
      this.$store.commit("set_sitePage_ttV2", data.sitePage);
      //定向包
      this.$store.commit("set_targeting_ttV2", data.targeting);
      //预算和出价
      this.$store.commit("set_budget_and_bid_ttV2", data.budgetBids);
      //创意组
      this.$store.commit("set_creative_groups_ttV2", data.creative_groups);
      //创意标题
      this.$store.commit("set_title_group_ttV2", data.title_group);
      //其他配置
      this.$store.commit("set_trackUrl_setting_ttV2", data.trackUrlSetting);
      //分配规则
      for (let [field, value] of Object.entries(data.splitRule)) {
        this.$store.commit("set_split_rule_ttV2", {
          key: field,
          value,
        });
      }
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.headerTplRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    // 转化跟踪，选择完回调事件
    chooseCallback(data) {
      this.chooseProductData = data;
      this.formData.selectPro = data.download_url;
      getAdertiserProduct({
        advertiserId: this.formData.adCount,
        pkg: data.package_name,
        downloadUrl: data.download_url,
      }).then((res) => {
        if (res.code === "0000") {
          this.$store.commit("setcheckedApp_ttV2", res.assets.app[0]);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .form-wrap {
    padding: 18px 24px 24px 24px;
    .form-item {
      display: flex;
      margin-bottom: 12px;
      .item-label {
        flex-shrink: 0;
        display: inline-block;
        width: 70px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .item-value {
        position: relative;
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
        /deep/ .el-form-item__content {
          line-height: 20px;
        }
        /deep/ .el-input-group__append {
          background: #1890ff;
          color: white;
          cursor: pointer;
          padding: 0;
          width: 70px;
          height: 31px;
          text-align: center;
          .is-disabled {
            width: 70px;
            height: 31px;
            background: #a0cfff;
          }
        }
        .add-tpl {
          padding: 0px;
        }
        .tpl-label {
          font-size: 12px;
          margin-left: 10px;
        }
        .select-tip {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          position: absolute;
          top: 4px;
          left: 0px;
          z-index: 100;
          pointer-events: none;
        }
        .product-name {
          font-size: 14px;
          margin-top: 6px;
          color: rgb(153, 153, 153);
        }
        .count-select-wrap {
          width: 320px;
          /deep/.el-select .el-input .el-select__caret {
            color: red;
          }
        }
        .select-list {
          margin: 0px;
          padding: 12px 12px 0px 12px;
          box-sizing: border-box;
          list-style: none;
          border-radius: 4px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: rgba(252, 252, 252, 1);
          display: flex;
          flex-wrap: wrap;
          max-height: 125px;
          overflow: auto;
          .select-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            border-radius: 2px;
            background: rgba(233, 233, 233, 0.6);
            padding: 2px 5px;
            margin: 0 12px 12px 0;
            white-space: nowrap;
            .close-btn {
              display: inline-block;
              margin-left: 6px;
              font-size: 18px;
              cursor: pointer;
              position: relative;
              top: 1px;
            }
          }
        }
      }
    }
  }
  .modal-body {
    .select-filter {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
    }
    .table-wrap {
      min-height: 400px;
    }
    .footer-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-wrap {
        display: flex;
        padding: 16px;
      }
      /deep/ .pagination-wrap {
        text-align: left;
      }
    }
  }
}
</style>
<style lang="less">
.pro-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
.count-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .count-option {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .count-item {
      display: block;
      line-height: 20px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
</style>
